export enum Device {
  PHONE,
  TABLET,
  DESKTOP
}
